import { type ReactNode } from "react";

const THeader = ({
  classNames,
  children,
}: {
  classNames?: string;
  children: ReactNode;
}) => {
  return (
    <thead className={classNames}>
      <tr>{children}</tr>
    </thead>
  );
};
export default THeader;
